'use client';

import { forwardRef } from 'react';

import type { PolymorphicForwardRefComponentV2 } from '../../utils/types';
import { ButtonBase, type ButtonBaseOwnProps } from './button-base.component';
import styles from './button-v2.component.module.scss';

export const ButtonV2 = forwardRef(
  ({ children, className, ...rest }, forwardRef) => {
    return (
      <ButtonBase
        className={[styles.buttonV2, className].filter(Boolean).join(' ')}
        ref={forwardRef}
        {...rest}
      >
        {children}
      </ButtonBase>
    );
  }
) as PolymorphicForwardRefComponentV2<
  'button',
  'button' | 'a',
  ButtonBaseOwnProps
>;
ButtonV2.displayName = 'ButtonV2';
